import React, { Component } from 'react'
import { DragLayer } from 'react-dnd'
import * as general from '../../constants/General'
import PropTypes from 'prop-types'

class ObjectItemDragLayer extends Component {
    renderItem(type, item, initialOffset) {
        if (initialOffset === null) {
            type = '';
        }
        switch (type) {
            case general.DND_OJECTITEMBUTTON:
                var itemsDiv = document.getElementById('items');
                var width = itemsDiv.clientWidth;
                var height = itemsDiv.clientHeight;

                var rootDiv = document.getElementById('root');
                var offset = rootDiv.clientHeight / 100.0 * 16;

                var previewWidth = width / 100.0 * item.width;
                var previewHeight = height / 100.0 * item.height;

                var y = initialOffset.y;
                y -= offset;

                const divstyle = {
                    width: `${previewWidth}px`,
                    height: `${previewHeight}px`,
                    position: 'absolute',
                    padding: '7px',
                    left: `${initialOffset.x}px`,
                    top: `${y}px`
                }

                return (
                    <div style={divstyle}>
                        <button className="om_itembutton">
                            <div className="om_itembuttonheader">
                                <div className="om_itemButtonText">
                                    {item.title}
                                </div>
                            </div>
                            <div className="om_itembuttonbody">
                                {item.number}
                            </div>
                        </button>
                    </div>);
            default:
                return (<div></div>);
        }
    }

    render() {
        const { item, itemType, isDragging, currentOffset } = this.props;
        if (!isDragging) {
            return null;
        }

        return (
            <div>
                {this.renderItem(itemType, item, currentOffset)}
            </div>
        );
    }
}

ObjectItemDragLayer.propTypes = {
    item: PropTypes.object,
    itemType: PropTypes.string,
    isDragging: PropTypes.bool,
    text: PropTypes.string,
    number: PropTypes.string,
    btnwidth: PropTypes.number,
    btnheight: PropTypes.number,
    btntop: PropTypes.number,
    btnleft: PropTypes.number
}

function collect(monitor) {
    return {
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging()
    }
}

export default DragLayer(collect)(ObjectItemDragLayer);



// WEBPACK FOOTER //
// src/objectmanagement/components/ObjectItemDragLayer.jsx